// Mirrors the backend's slug logic (sope-backend `slugify`) so that a link
// generated on the client always equals the slug the server matches against
// (the API does `slugify(name) === req.params.slug`).
//
// It lowercases, trims, turns runs of whitespace into hyphens, then strips
// every character that isn't a letter, number, underscore or hyphen. That
// means commas, slashes, ampersands, accents and other special characters are
// removed in exactly the same way on both sides — so titles like
// "Fashion, Editorial" resolve to "fashion-editorial" and open correctly.
export const slugify = (text = '') =>
  text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // spaces -> hyphens
    .replace(/[^\w-]+/g, '') // drop anything that isn't a-z, 0-9, _ or -

export default slugify
